import { actions } from './actions'

const initialState = {
  distribuidores: {
    data: [],
    loading: false,
    error: '',
  },
}

export default function distribuidoresReducer(state = initialState, action) {
  switch (action.type) {
    case actions.DISTRIBUIDORES_LOAD_REQUESTED:
      return {
        ...state,
        distribuidores: { ...state.distribuidores, loading: true },
      }
    case actions.DISTRIBUIDORES_LOAD_SUCCEEDED:
      return {
        ...state,
        distribuidores: { ...state.distribuidores, data: action.payload, loading: false },
      }
    case actions.DISTRIBUIDORES_LOAD_FILED:
      return {
        ...state,
        distribuidores: { ...state.distribuidores, loading: false, error: action.error },
      }
    default:
      return state
  }
}
